import api from './api';

export function getVapidPublicKey() {
  return api.get('/notifications/vapid-public-key').then(res => res.data);
}

export function subscribePush(subscription) {
  return api.post('/notifications/subscribe', subscription).then(res => res.data);
}

export function getDeviceNotificationRules(deviceId) {
  return api
    .get(`/notifications/rules/${deviceId}`)
    .then(res => res.data);
}

export function saveDeviceNotificationRules(deviceId, rules) {
  return api
    .put(`/notifications/rules/${deviceId}`, { rules })
    .then(res => res.data);
}